import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
const TableView = ({ dataset = [], columns = [], rowClass, keyColumn }) => {
  return (
    <TableContainer sx={{ overflowX: "auto" }} style={{ maxHeight: '90vh' }}>
      <Table size="small" stickyHeader aria-label="sticky table" sx={{ width: 'max-content', minWidth: '100%' }}>
        <TableHead>
          <TableRow>
            {columns.map((column, colIndex) =>
              column.type !== "checkbox" ? (
                <TableCell
                  key={`header-${colIndex}`}
                  sx={{ width: column.width, minWidth: column.minWidth }}
                >
                  {column.label ?? "-"}
                </TableCell>
              ) : null
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataset.length === 0 ? (
            <TableRow key="no-data">
              <TableCell colSpan={columns.length || 1}>データがありません</TableCell>
            </TableRow>
          ) : (
            dataset.map((item, rowIndex) => (
              <TableRow
                key={keyColumn && item?.[keyColumn] != null ? item[keyColumn] : rowIndex}
                className={rowClass}
              >
                {columns.map((column, colIndex) =>
                  column.type !== "checkbox" ? (
                    <TableCell
                      key={`${rowIndex}-${colIndex}`}
                      sx={{ width: column.width }}
                    >
                      {column.format
                        ? column.format(item?.[column.accessor], item)
                        : column.render
                          ? column.render(item, rowIndex)
                          : item?.[column.accessor] ?? "-"}
                    </TableCell>
                  ) : null
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TableView;
